import { prepareFileInfo } from 'js/file_viewer/core/utils/support';
import { createPreviewMetadataQueryKey } from 'js/react_query_helpers/queries/preview_metadata';
import { queryClient } from 'js/state/src/query_client/query_client';
function isPreviewMetadata(metadata) {
    return 'content' in metadata;
}
export function isPreviewError(metadata) {
    return !('content' in metadata);
}
export const maybeCopyPreviewMetadataIntoQueryClient = (previewMetadata, fileInfo, fileSize, sharedLinkInfo) => {
    if (previewMetadata && !isPreviewMetadataPopulated(fileInfo, sharedLinkInfo)) {
        if (isPreviewMetadata(previewMetadata)) {
            setPreviewMetadata(previewMetadata, fileInfo, fileSize, sharedLinkInfo);
        }
        else if (isPreviewError(previewMetadata)) {
            setPreviewMetadata(undefined, fileInfo, fileSize, sharedLinkInfo, previewMetadata);
        }
    }
};
export const setPreviewMetadata = (previewMetadata, fileInfo, fileSize, sharedLinkInfo, error) => {
    const preparedFileInfo = prepareFileInfo(fileInfo, sharedLinkInfo);
    const previewFile = {
        preview: previewMetadata,
        file: preparedFileInfo,
        file_size: fileSize,
        err: error,
    };
    const result = {
        results: [previewFile],
    };
    queryClient.setQueryData(createPreviewMetadataQueryKey({ files: [preparedFileInfo], include_dimensions: true }), {
        apiData: result,
        pkgData: null,
    });
};
const isPreviewMetadataPopulated = (file, sharedLinkInfo) => {
    const preparedFileInfo = prepareFileInfo(file, sharedLinkInfo);
    const args = {
        files: [preparedFileInfo],
        include_dimensions: true,
    };
    return queryClient.getQueryData(createPreviewMetadataQueryKey(args)) !== undefined;
};
//# sourceMappingURL=preview_metadata.preenvesnextjs.map
